const SELLING_PLAN_ID_INPUT = document.getElementById('mmSellingPlanId');

// Les options de plans sont re-rendues à chaque changement de variante (zone .mm-reload).
// On les requête donc en direct à chaque appel pour ne pas garder de références obsolètes.
function getSellingPlanOptions() {
  return document.querySelectorAll('.mm-selling-plan-option');
}
function getSubscriptionLabels() {
  return document.querySelectorAll('.mm-rc-subscription-label');
}

function mmSubscriptionMethodChanged(selected_selling_method) {
  const method = selected_selling_method.value;
  const sellingPlanOptions = getSellingPlanOptions();

  if(method == 'one_time') {
    SELLING_PLAN_ID_INPUT.value = "";
    sellingPlanOptions.forEach(function(sellingPlanOption) {
      sellingPlanOption.checked= false;
    })
    getSubscriptionLabels().forEach(function(SUBSCRIPTION_LABEL) {
      SUBSCRIPTION_LABEL.classList.remove('mm-open');
    })
  } else {
    const plan_selected = document.querySelector('.mm-selling-plan-option:checked');
    if (plan_selected) {
      SELLING_PLAN_ID_INPUT.value = plan_selected.value;
    } else if (sellingPlanOptions.length > 0) {
      sellingPlanOptions[0].checked = true;
      SELLING_PLAN_ID_INPUT.value = sellingPlanOptions[0].value;
    }
    getSubscriptionLabels().forEach(function(SUBSCRIPTION_LABEL) {
      SUBSCRIPTION_LABEL.classList.add('mm-open');
    })
  }

  // get new price
  const label = selected_selling_method.nextElementSibling;
  const priceContainer = label ? label.querySelector('.mm-rc-price') : null;
  
  if (priceContainer) {
    // Extraire le prix et le prix barré de la structure .mm-rc-price
    const compareAtPriceElem = priceContainer.querySelector('s');
    const priceElem = priceContainer.querySelector('p');
    
    // Construire le HTML pour le CTA avec la bonne structure (identique à celle du Liquid)
    let priceHTML = '';
    if (compareAtPriceElem) {
      priceHTML += '<s class="">' + compareAtPriceElem.textContent.trim() + '</s>';
    }
    if (priceElem) {
      priceHTML += priceElem.textContent.trim();
    }
    
    // Mettre à jour le prix dans tous les CTAs
    const CTAs = document.querySelectorAll('.mm-main-product-cta');
    CTAs.forEach(function(CTA) {
      const priceElement = CTA.querySelector('.mm-product-price');
      if (priceElement && priceHTML) {
        priceElement.innerHTML = priceHTML;
        // Mettre à jour aussi l'attribut data-price si présent
        if (priceElem) {
          // Extraire les chiffres du prix (format français avec virgule ou point)
          const priceText = priceElem.textContent.trim();
          const priceValue = priceText.replace(/[^\d,.]/g, '').replace(',', '.');
          if (priceValue) {
            const priceInCents = Math.round(parseFloat(priceValue) * 100);
            priceElement.setAttribute('data-price', priceInCents);
          }
        }
      }
    });
  }
}

function syncRcElements(clickedLabel) {
  const inputValue = clickedLabel.value;
  const elems = document.querySelectorAll(`.mm-selling-plans-elem input[value="${inputValue}"]`);
  elems.forEach(function(elem) {
    elem.click();
  })
}

function mmSubscriptionPlanChanged(selected_selling_plan) {
  const selected_selling_plan_id = selected_selling_plan.value;

  SELLING_PLAN_ID_INPUT.value = selected_selling_plan_id;
  
  // Mettre à jour le prix dans le CTA si on est en mode abonnement
  const subscriptionInput = document.querySelector('input[name^="purchase_option"][value="subscription"]:checked');
  if (subscriptionInput) {
    mmSubscriptionMethodChanged(subscriptionInput);
  }
}

document.addEventListener("DOMContentLoaded", function () {
	// Récupérer l'élément actuellement sélectionné (chercher tous les noms possibles)
	const selectedSellingMethod = document.querySelector('input[name="purchase_option"]:checked') || 
	                               document.querySelector('input[name^="purchase_option"]:checked');

	// Vérifier si un élément est sélectionné et appeler la fonction
	if (selectedSellingMethod) {
		mmSubscriptionMethodChanged(selectedSellingMethod);
	} else {
		// Si aucun élément n'est sélectionné, initialiser avec le premier plan d'abonnement si disponible
		const subscriptionInput = document.querySelector('input[name^="purchase_option"][value="subscription"]');
		const sellingPlanOptions = getSellingPlanOptions();
		if (subscriptionInput && SELLING_PLAN_ID_INPUT && sellingPlanOptions.length > 0) {
			// Si subscription est disponible, le sélectionner par défaut et initialiser le plan
			subscriptionInput.checked = true;
			sellingPlanOptions[0].checked = true;
			SELLING_PLAN_ID_INPUT.value = sellingPlanOptions[0].value;
			mmSubscriptionMethodChanged(subscriptionInput);
		}
	}
});
